import { FundsLoadingTypes, BenefitType } from '@epi-constants/benefitTypes';
import {
  LoadBenefitPageType,
  LoadBenefitPageTypes
} from '@epi-constants/onboardingTypes';
import { IBenefits } from '@epi-models/pages/BenefitGroups';
import { LunchFundsLoadingValues } from '@epi-models/pages/Home';

export const hasLunchBenefit = (benefits: Array<string | IBenefits>): boolean =>
  benefits.some(benefit => benefit.toLowerCase() === BenefitType.Lunch);

export const hasNonLunchBenefits = (
  benefits: Array<string | IBenefits>
): boolean =>
  benefits.some(benefit => benefit.toLowerCase() !== BenefitType.Lunch);

export const getInitialLoadBenefitPageType = (
  lunchFundsLoadingType: LunchFundsLoadingValues | null,
  availableBenefits: Array<string | IBenefits>
): LoadBenefitPageType => {
  const hasLunch = hasLunchBenefit(availableBenefits);
  const hasOthers = hasNonLunchBenefits(availableBenefits);

  if (!hasLunch) {
    return hasOthers
      ? LoadBenefitPageTypes.Others
      : LoadBenefitPageTypes.Default;
  }

  if (!hasOthers) {
    return LoadBenefitPageTypes.Lounari;
  }

  if (lunchFundsLoadingType === FundsLoadingTypes.DirectLoad) {
    return LoadBenefitPageTypes.Lounari;
  }

  if (lunchFundsLoadingType === FundsLoadingTypes.TopUpRequest) {
    return LoadBenefitPageTypes.Others;
  }

  return LoadBenefitPageTypes.Default;
};

export const reconcileLoadBenefitPageType = (
  _storedPageType: LoadBenefitPageType,
  availableBenefits: IBenefits[],
  isSecondStep: boolean,
  lunchFundsLoadingType: LunchFundsLoadingValues | null
): LoadBenefitPageType => {
  const hasLunch = hasLunchBenefit(availableBenefits);
  const hasOthers = hasNonLunchBenefits(availableBenefits);

  if (!hasLunch && !hasOthers) {
    return LoadBenefitPageTypes.Default;
  }

  if (!hasLunch) {
    return LoadBenefitPageTypes.Others;
  }

  if (!hasOthers) {
    return LoadBenefitPageTypes.Lounari;
  }

  if (isSecondStep) {
    return LoadBenefitPageTypes.Others;
  }

  return getInitialLoadBenefitPageType(
    lunchFundsLoadingType,
    availableBenefits
  );
};
